var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66,
    y: 4.23,
    width: 20.04,
    height: 1.51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.22,
    y: 4.26,
    width: 1.51,
    height: 24.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66,
    y: 27.45,
    width: 20.04,
    height: 1.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.56,
    y: 15.07,
    width: 10.82,
    height: 1.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.56,
    y: 18.17,
    width: 10.82,
    height: 1.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.56,
    y: 21.26,
    width: 10.82,
    height: 1.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 7.35,
    width: 1.51,
    height: 1.51
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 10.44,
    width: 1.51,
    height: 1.51
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 13.52,
    width: 1.51,
    height: 1.51
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 16.62,
    width: 1.51,
    height: 1.51
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 19.71,
    width: 1.51,
    height: 1.51
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.56,
    y: 22.83,
    width: 1.51,
    height: 1.51
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.61,
    y: 25.95,
    width: 1.51,
    height: 1.51
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 27.45,
    width: 1.51,
    height: 1.51
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 24.39,
    width: 1.51,
    height: 1.51
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 21.26,
    width: 1.51,
    height: 1.51
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 18.16,
    width: 1.51,
    height: 1.51
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 15.06,
    width: 1.51,
    height: 1.51
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 11.98,
    width: 1.51,
    height: 1.51
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 8.91,
    width: 1.51,
    height: 1.51
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06,
    y: 5.84,
    width: 1.51,
    height: 1.51
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.56,
    y: 8.67,
    width: 10.82,
    height: 3.15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarReports);
export default __webpack_public_path__ + "static/media/toolbar-reports.bc69599f.svg";
export { ForwardRef as ReactComponent };